import React from 'react';
import ReactDOM from 'react-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import { ToastContainer } from 'react-toastify';
import * as serviceWorker from './serviceWorker';
import configureStore from './ducks';
import Routes from './templates';
import './index.css';
import 'react-toastify/dist/ReactToastify.min.css';
import { momenti18n } from './i18n/momenti18n';

const theme = createMuiTheme({
  palette: {
    primary: { main: '#01caff' },
    secondary: { main: '#01caff' },
  },
  typography: {
    useNextVariants: true,
  },
});

const { store, persistor } = configureStore();

function App() {
  React.useEffect(() => {
    momenti18n();
  }, []);
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <MuiThemeProvider theme={theme}>
          <div>
            <ToastContainer />
            <Routes />
          </div>
        </MuiThemeProvider>
      </PersistGate>
    </Provider>
  );
}

ReactDOM.render(<App />, document.getElementById('root'));

export { store };

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
